class SlideShow {

  constructor (slideObj,slideRandom) {
    this.currentSlideNum = 0;
    this.intervalTime = 6000;
    this.fadeDuration = 1000;
    this.slideObj = slideObj;
    this.slideRandom = slideRandom;
    this.slides = this.slideObj.children('div');
    this.slides.css({
      'display': 'none'
    });
    this.si = null;
    this.slides.each(function(i) {
      $(this).addClass('slide' + i);
    });
    if (this.slideRandom) {
      let arr = [];
      this.slides.each(function() {
        arr.push($(this)[0].outerHTML);
      });
      arr = this._shuffle(arr);
      this.slideObj.empty();
      for (let j = 0; j < arr.length; j++) {
        this.slideObj.append(arr[j]);
      }
    }
    const slidelength = this.slides.length;
    this.slides.each(function(i,el) {
      $(el).css({
        zIndex: slidelength - i
      });
    });
  }
  start (){
    this.slides.eq(this.currentSlideNum).show();
    this._setSi();
  }
  _shuffle(array) {
    var n = array.length, t, i;

    while (n) {
      i = Math.floor(Math.random() * n--);
      t = array[n];
      array[n] = array[i];
      array[i] = t;
    }

    return array;
  }
  _setSi(){
    const self = this;
    this.si = setInterval(function(){
      let num = parseInt(self.currentSlideNum) + parseInt(1);
      if (num >= self.slides.length) {
        num = 0;
      }
      self._change(num);
    },this.intervalTime);
  }
  _fadeOut(num) {
    this.slides.eq(num).fadeOut(this.fadeDuration, function() {
      return $(this).css({
        zIndex: 1
      });
    });
  }
  _change(num) {
    this.slides.eq(this.currentSlideNum).stop().fadeIn();
    this.slides.eq(num).stop().css({
      opacity: 1
    });
    this.slides.eq(this.currentSlideNum).css({
      zIndex: this.slides.length
    });
    this.slides.eq(num).css({
      zIndex: this.slides.length - 1
    });
    this._fadeOut(this.currentSlideNum);
    this.currentSlideNum = num;
    this.slides.eq(this.currentSlideNum).show();
  }
}

export default SlideShow;
